import React from 'react';
import { motion } from 'framer-motion';
const items = [{
  label: 'A select group of women.',
  detail: 'Thoughtfully gathered. Open to who you are.'
}, {
  label: 'One beautiful shared home.',
  detail: 'Chosen for light, stillness, and space.'
}, {
  label: 'Hosts rooted in the place.',
  detail: 'Artists, makers, women who know.'
}, {
  label: 'A week with a new pulse.',
  detail: 'Slow mornings. Long dinners. Real conversations.'
}, {
  label: 'A way home that feels different.',
  detail: 'You arrive a guest. You leave changed.'
}];
export function Invitation() {
  return <section className="bg-bone py-28 md:py-40 px-6 md:px-12" data-id="element-123">
      <div className="max-w-3xl mx-auto" data-id="element-124">
        <div className="text-center mb-20" data-id="element-125">
          <p className="eyebrow mb-6" data-id="element-126">Inside the invitation</p>
          <motion.h2 initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.9
        }} className="font-serif-display text-3xl md:text-5xl leading-[1.1] text-ink" data-id="element-127">
            The journey <span className="italic" data-id="element-128">that awaits you.</span>
          </motion.h2>
        </div>

        <div className="relative pl-10 md:pl-14" data-id="element-129">
          {/* Animated vertical line */}
          <motion.div initial={{
          scaleY: 0
        }} whileInView={{
          scaleY: 1
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 1.8,
          ease: [0.65, 0, 0.35, 1]
        }} style={{
          transformOrigin: 'top'
        }} className="absolute left-1.5 md:left-2.5 top-2 bottom-2 w-px bg-ink/25" data-id="element-130" />

          <ul className="space-y-12 md:space-y-14" data-id="element-131">
            {items.map((item, i) => <motion.li key={item.label} initial={{
            opacity: 0,
            x: -8
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true,
            margin: '-80px'
          }} transition={{
            duration: 0.7,
            delay: 0.3 + i * 0.18
          }} className="relative" data-id="element-132">
                {/* Dot marker */}
                <span className="absolute -left-10 md:-left-14 top-2 w-3 h-3 rounded-full bg-sun" data-id="element-133" />
                <p className="font-serif-display text-2xl md:text-3xl text-ink leading-snug" data-id="element-134">
                  {item.label}
                </p>
                <p className="mt-2 text-ink-soft text-[14px] md:text-[15px] leading-[1.7]" data-id="element-135">
                  {item.detail}
                </p>
              </motion.li>)}
          </ul>
        </div>
      </div>
    </section>;
}